import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { DefaultBadge, LiveBadge } from './Badge.style';

const GameStateBadgeMap = {
    default: DefaultBadge,
    live: LiveBadge
};

const GameStateBadge = ({
    text,
    dictkey,
    type = 'default'
}) => {
    const translate = useTranslate();

    if (!text || !type || typeof GameStateBadgeMap[type] === 'undefined') {
        return null;
    }

    const label = translate(dictkey, text);
    const Badge = GameStateBadgeMap?.[type];
    return <Badge>{label}</Badge>;
};

GameStateBadge.propTypes = {
    text: PropTypes.string,
    dictkey: PropTypes.string,
    type: PropTypes.oneOf(['default', 'live'])
};

export default GameStateBadge;
